/*
 * @Author: zhoubiao
 * @Date: 2021-03-23 12:16:44
 * @LastEditors: zhoubiao
 * @LastEditTime: 2021-05-17 14:11:25
 * @FilePath: \ICCSIP2020\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n/i18n'
// 引入
import './plugins/element.js'
import './assets/css/global.css'

Vue.config.productionTip = false

new Vue({
  components: {
    App //在 index.html页面不使用这个组件，就会返回 We're sorry but demo3 doesn't work properly without JavaScript enabled. Please enable it to continue.
  },
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
